export default __webpack_public_path__ + "static/media/af9.343fa8e9.jpg";